/**
 * Returns a safe in-app path for post-login navigation from the `redirect` query param.
 * Rejects open redirects (e.g. protocol-relative `//evil.com`, absolute URLs).
 */
export function getSafePostLoginPath(redirectParam: string | null): string {
  if (redirectParam == null || redirectParam === '') return '/app';
  let decoded: string;
  try {
    decoded = decodeURIComponent(redirectParam);
  } catch {
    return '/app';
  }
  const trimmed = decoded.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return '/app';
  return trimmed;
}
